import React, { useEffect } from "react";
function useKeysPress(callbacks: ((param?: any) => any)[]) {
  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      switch (e.key) {
        case "a":
          callbacks[0]?.();
          break;
        case "b":
          callbacks[1]?.();
          break;
        case "c":
          callbacks[2]?.();
          break;
        default:
          break;
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [callbacks]);
}

export default useKeysPress;
